import React, { useState } from 'react';

import { useGetAutomatedInfo } from '../../../../hooks/useGetAutomatedInfo';
import { AutoresponderToggle } from './components/AutoresponderToggle';
import { OptionsSection } from './components/OptionsSection';

export const AutoresponderOptions = (): JSX.Element => {
    const { isAutomatedEdit } = useGetAutomatedInfo();
    const [autoresponderChecked, setAutoresponderChecked] = useState(isAutomatedEdit);

    return (
        <>
            <AutoresponderToggle
                autoresponderChecked={autoresponderChecked}
                setAutoresponderChecked={setAutoresponderChecked}
            />
            {autoresponderChecked && <OptionsSection />}
        </>
    );
};
